/*
    Created By: Sai Prasad
    Created Date: 26/08/2022
    Jira Ticket: JUN-3152
    Description: capturing items imported response and showing to user in a popup.
  */

import React from 'react';
import '../../pages/ServiceRequest/Popup.scss';
import Row from '../Row';
import Col from '../Col';

const ItemsResponsePopup = ({
  data,
  onPress
}) => {
  return (
    <div className='suites_popup'>
      <div className='custom_inside_popup'>
        <div style={{ textAlign: 'right' }}>
          <div style={{ textAlign: 'right' }}>
            <div className="filters_modal_top_coner_box">
              <div className="filters_modal_close_icon" onClick={onPress}>
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z" fill="black" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className='suite_heading' style={{ marginBottom: 20 }}>Items Uploaded Information</div>
          {data.map((item, i) => {
            return (
              <div style={{ flexDirection: 'row', borderBottom: '1px solid #ccc', marginBottom: 10 }} key={i}>
                <div style={{ marginBottom: 5 }}>
                  <Row>
                    <Col
                      xs="12"
                      md="3">
                      <b className='area_name'>Item:</b><span className='area_name'> {item.name}</span>
                    </Col>
                    <Col
                      xs="12"
                      md="3">
                      <b className='area_name'>Type:</b> <span className='area_name'>{item.type}</span>
                    </Col>
                    <Col
                      xs="12"
                      md="3">
                      <b className='area_name'>Status:</b> <span className={item.status === "Success" ? 'area_name success' : 'area_name fail'}>
                        {item.status}</span>
                    </Col>
                    {item.message &&
                      <Col
                        xs="12"
                        md="3">
                        <b className='area_name'>Message:</b> <span className={item.status === "Success" ? 'area_name success' : 'area_name fail'}>{item.message}</span>
                      </Col>}
                  </Row>
                </div>
                {item.properties && item.properties.length > 0 &&
                  <div style={{ marginBottom: 5, marginTop: 10 }}>
                    <Row>
                      <Col
                        xs="12"
                        md="3">
                        <b className='area_name' style={{ fontSize: 14 }}>Property Information:</b>
                      </Col>
                      <Col
                        xs="12"
                        md="9">
                        <Row>
                          {item.properties.map((property, k) => {
                            return (
                              <Col
                                key={k}
                                xs="12"
                                md="4"
                              >
                                <div style={{ paddingBottom: 10 }}>
                                  <div className='asset_name_style'>{property.name}</div> <div className={property.status === "Success" ? 'success asset_name_style' : 'fail asset_name_style'}>{property.status}</div>
                                  <div className={property.status === "Success" ? 'success asset_name_style' : 'fail asset_name_style'}>{property.message}</div>
                                </div>
                              </Col>
                            )
                          })}
                        </Row>
                      </Col>
                    </Row>
                  </div>}
              </div>
            )
          })}

        </div>
      </div>
    </div>
  )
}

export default ItemsResponsePopup;